import React from "react";

import Login from "./Login";
import ChangePassword from "./changePassword";
import { useLoginWrapperState } from "./hooks/useLoginWrapperState";

const LoginWrapper = () => {
  const {
    showChangePassword,
    userData,
    authToken,
    handleLogin,
    handlePasswordChangeSuccess,
  } = useLoginWrapperState();

  return (
    <div>
      {!showChangePassword ? (
        <Login onLogin={handleLogin} />
      ) : (
        <ChangePassword
          userData={userData}
          authToken={authToken}
          onSuccess={handlePasswordChangeSuccess}
        />
      )}
    </div>
  );
};

export default LoginWrapper;
